export enum FileKindEnum {
  KnowledgePage = 'knowledge_page',
  Scribe = 'scribe',
}
